import { useTasksByLifeAreaId } from 'features/tasks';
import { ID } from 'shared/types/id';

export const useCompletedLifeAreaTasks = (id?: ID) =>
  useTasksByLifeAreaId(id, { completedOnly: true });
